
namespace TabAurous.HR {

    @Serenity.Decorators.registerClass()
    export class IncomeTaxSlabsGrid extends _Ext.GridBase<IncomeTaxSlabsRow, any> {
        protected getColumnsKey() { return 'HR.IncomeTaxSlabs'; }
        protected getDialogType() { return IncomeTaxSlabsDialog; }
        protected getIdProperty() { return IncomeTaxSlabsRow.idProperty; }
        protected getInsertPermission() { return IncomeTaxSlabsRow.insertPermission; }
        protected getLocalTextPrefix() { return IncomeTaxSlabsRow.localTextPrefix; }
        protected getService() { return IncomeTaxSlabsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}